import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import styles from '../table.module.scss';
const cx = classnames.bind(styles);

export default class ComponentCell extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { updated: false };
  }

  componentWillUpdate(nextProps) {
    if (nextProps.value !== this.props.value) {
      this.setState({ updated: true });
      this.timeout = setTimeout(() => {
        this.setState({ updated: false });
      }, 700);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  render() {
    const {
      row,
      col,
      readOnly,
      forceComponent,
      rowSpan,
      colSpan,
      width,
      overflow,
      value,
      className,
      editing,
      selected,
      onMouseDown,
      onMouseOver,
      onDoubleClick,
      onContextMenu,
      attributes,
    } = this.props;
    const style = { width };

    return (
      <td
        className={cx(
          // className,
          'editor-cell',
          { overflow: overflow },
          { editing },
          { selected },
          { 'read-only': readOnly },
          { updated: this.state.updated },
        )}
        onMouseDown={() => onMouseDown(row, col)}
        onDoubleClick={() => onDoubleClick(row, col)}
        onMouseOver={() => onMouseOver(row, col)}
        onContextMenu={e => onContextMenu(e, row, col)}
        colSpan={colSpan || 1}
        rowSpan={rowSpan || 1}
        style={style}
        {...attributes}
      >
        {(editing && !readOnly) || forceComponent
          ? this.props.component
          : value}
      </td>
    );
  }
}

ComponentCell.propTypes = {
  row: PropTypes.number.isRequired,
  col: PropTypes.number.isRequired,
  colSpan: PropTypes.number,
  rowSpan: PropTypes.number,
  width: PropTypes.string,
  overflow: PropTypes.oneOf(['wrap', 'nowrap', 'clip']),
  className: PropTypes.string,
  selected: PropTypes.bool.isRequired,
  editing: PropTypes.bool.isRequired,
  onMouseDown: PropTypes.func.isRequired,
  onDoubleClick: PropTypes.func.isRequired,
  onMouseOver: PropTypes.func.isRequired,
  onContextMenu: PropTypes.func.isRequired,
  updated: PropTypes.bool,
  forceComponent: PropTypes.bool,
  attributes: PropTypes.object,
};
